import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// Translations
const translations = {
  // Navigation
  'nav.dashboard': { en: 'Dashboard', th: 'แดชบอร์ด' },
  'nav.branches': { en: 'Branches', th: 'สาขา' },
  'nav.users': { en: 'Users', th: 'ผู้ใช้งาน' },
  'nav.admins': { en: 'Admins', th: 'ผู้ดูแลระบบ' },
  'nav.logout': { en: 'Logout', th: 'ออกจากระบบ' },
  'nav.more': { en: 'More', th: 'เพิ่มเติม' },
  'nav.menu': { en: 'Menu', th: 'เมนู' },

  // Auth
  'auth.login': { en: 'Login', th: 'เข้าสู่ระบบ' },
  'auth.signup': { en: 'Sign Up', th: 'ลงทะเบียน' },
  'auth.email': { en: 'Email', th: 'อีเมล' },
  'auth.password': { en: 'Password', th: 'รหัสผ่าน' },
  'auth.confirmPassword': { en: 'Confirm Password', th: 'ยืนยันรหัสผ่าน' },
  'auth.name': { en: 'Name', th: 'ชื่อ' },
  'auth.forgotPassword': { en: 'Forgot Password?', th: 'ลืมรหัสผ่าน?' },
  'auth.noAccount': { en: "Don't have an account?", th: 'ยังไม่มีบัญชี?' },
  'auth.hasAccount': { en: 'Already have an account?', th: 'มีบัญชีอยู่แล้ว?' },
  'auth.resetPassword': { en: 'Reset Password', th: 'รีเซ็ตรหัสผ่าน' },
  'auth.newPassword': { en: 'New Password', th: 'รหัสผ่านใหม่' },
  'auth.sendResetLink': { en: 'Send Reset Link', th: 'ส่งลิงก์รีเซ็ต' },
  'auth.backToLogin': { en: 'Back to Login', th: 'กลับไปหน้าเข้าสู่ระบบ' },
  'auth.verifyEmail': { en: 'Verify Email', th: 'ยืนยันอีเมล' },
  'auth.verifying': { en: 'Verifying...', th: 'กำลังยืนยัน...' },
  'auth.verified': { en: 'Email verified successfully!', th: 'ยืนยันอีเมลสำเร็จ!' },
  'auth.checkEmail': { en: 'Please check your email for verification link', th: 'กรุณาตรวจสอบอีเมลของคุณเพื่อยืนยัน' },

  // Dashboard
  'dashboard.welcome': { en: 'Welcome', th: 'ยินดีต้อนรับ' },
  'dashboard.totalBranches': { en: 'Total Branches', th: 'จำนวนสาขา' },
  'dashboard.totalUsers': { en: 'Total Users', th: 'จำนวนผู้ใช้' },
  'dashboard.totalAdmins': { en: 'Total Admins', th: 'จำนวนผู้ดูแล' },
  'dashboard.totalDentists': { en: 'Total Dentists', th: 'จำนวนทันตแพทย์' },
  'dashboard.totalPatients': { en: 'Total Patients', th: 'จำนวนผู้ป่วย' },
  'dashboard.licenseExpiry': { en: 'License Expiry', th: 'วันหมดอายุใบอนุญาต' },
  'dashboard.daysRemaining': { en: 'Days Remaining', th: 'วันที่เหลือ' },
  'dashboard.pendingAdmins': { en: 'admin(s) pending verification', th: 'ผู้ดูแลรอการยืนยัน' },
  'dashboard.accountInfo': { en: 'Account Information', th: 'ข้อมูลบัญชี' },
  'dashboard.quickActions': { en: 'Quick Actions', th: 'การดำเนินการด่วน' },
  'dashboard.manageBranches': { en: 'Manage Branches', th: 'จัดการสาขา' },
  'dashboard.manageUsers': { en: 'Manage Users', th: 'จัดการผู้ใช้' },
  'dashboard.manageAdmins': { en: 'Manage Admins', th: 'จัดการผู้ดูแล' },

  // Branches
  'branch.name': { en: 'Branch Name', th: 'ชื่อสาขา' },
  'branch.address': { en: 'Address', th: 'ที่อยู่' },
  'branch.phone': { en: 'Phone', th: 'โทรศัพท์' },
  'branch.email': { en: 'Email', th: 'อีเมล' },
  'branch.manager': { en: 'Manager', th: 'ผู้จัดการ' },
  'branch.vatNumber': { en: 'VAT Number', th: 'เลขประจำตัวผู้เสียภาษี' },
  'branch.businessLicense': { en: 'Business License', th: 'ใบอนุญาตประกอบกิจการ' },
  'branch.dentalLicense': { en: 'Dental License', th: 'ใบอนุญาตคลินิกทันตกรรม' },
  'branch.openTime': { en: 'Open Time', th: 'เวลาเปิด' },
  'branch.closeTime': { en: 'Close Time', th: 'เวลาปิด' },
  'branch.openDays': { en: 'Open Days', th: 'วันที่เปิด' },
  'branch.language': { en: 'Language', th: 'ภาษา' },
  'branch.smartcardEnabled': { en: 'Smartcard Enabled', th: 'เปิดใช้งานสมาร์ทการ์ด' },
  'branch.dentistLimit': { en: 'Dentist Limit', th: 'จำนวนทันตแพทย์สูงสุด' },
  'branch.logo': { en: 'Logo', th: 'โลโก้' },
  'branch.userCount': { en: 'Users', th: 'ผู้ใช้' },
  'branch.dentistCount': { en: 'Dentists', th: 'ทันตแพทย์' },
  'branch.addBranch': { en: 'Add Branch', th: 'เพิ่มสาขา' },
  'branch.editBranch': { en: 'Edit Branch', th: 'แก้ไขสาขา' },

  // Users
  'user.name': { en: 'Name', th: 'ชื่อ' },
  'user.email': { en: 'Email', th: 'อีเมล' },
  'user.password': { en: 'Password', th: 'รหัสผ่าน' },
  'user.role': { en: 'Role', th: 'บทบาท' },
  'user.branch': { en: 'Branch', th: 'สาขา' },
  'user.status': { en: 'Status', th: 'สถานะ' },
  'user.addUser': { en: 'Add User', th: 'เพิ่มผู้ใช้' },
  'user.editUser': { en: 'Edit User', th: 'แก้ไขผู้ใช้' },
  'user.resetPassword': { en: 'Reset Password', th: 'รีเซ็ตรหัสผ่าน' },
  'user.roleAdmin': { en: 'Admin', th: 'ผู้ดูแล' },
  'user.roleOfficer': { en: 'Officer', th: 'เจ้าหน้าที่' },
  'user.actions': { en: 'Actions', th: 'จัดการ' },

  // Admins
  'admin.name': { en: 'Name', th: 'ชื่อ' },
  'admin.email': { en: 'Email', th: 'อีเมล' },
  'admin.status': { en: 'Status', th: 'สถานะ' },
  'admin.licenseExpiry': { en: 'License Expiry', th: 'วันหมดอายุ' },
  'admin.createdAt': { en: 'Created At', th: 'วันที่สร้าง' },
  'admin.editAdmin': { en: 'Edit Admin', th: 'แก้ไขผู้ดูแล' },
  'admin.superAdmin': { en: 'Super Admin', th: 'ผู้ดูแลหลัก' },

  // Common
  'common.save': { en: 'Save', th: 'บันทึก' },
  'common.cancel': { en: 'Cancel', th: 'ยกเลิก' },
  'common.close': { en: 'Close', th: 'ปิด' },
  'common.delete': { en: 'Delete', th: 'ลบ' },
  'common.edit': { en: 'Edit', th: 'แก้ไข' },
  'common.add': { en: 'Add', th: 'เพิ่ม' },
  'common.search': { en: 'Search', th: 'ค้นหา' },
  'common.filter': { en: 'Filter', th: 'กรอง' },
  'common.actions': { en: 'Actions', th: 'การดำเนินการ' },
  'common.loading': { en: 'Loading...', th: 'กำลังโหลด...' },
  'common.noData': { en: 'No data found', th: 'ไม่พบข้อมูล' },
  'common.confirmDelete': { en: 'Are you sure you want to delete?', th: 'คุณแน่ใจหรือไม่ว่าต้องการลบ?' },
  'common.success': { en: 'Success', th: 'สำเร็จ' },
  'common.error': { en: 'Error', th: 'ผิดพลาด' },
  'common.active': { en: 'Active', th: 'ใช้งาน' },
  'common.inactive': { en: 'Inactive', th: 'ไม่ใช้งาน' },
  'common.pending': { en: 'Pending', th: 'รอดำเนินการ' },
  'common.all': { en: 'All', th: 'ทั้งหมด' },
  'common.yes': { en: 'Yes', th: 'ใช่' },
  'common.no': { en: 'No', th: 'ไม่' },
  'common.uploadImage': { en: 'Click to upload image', th: 'คลิกเพื่ออัพโหลดรูปภาพ' },
  'common.removeImage': { en: 'Remove Image', th: 'ลบรูปภาพ' },

  // Days
  'day.monday': { en: 'Monday', th: 'จันทร์' },
  'day.tuesday': { en: 'Tuesday', th: 'อังคาร' },
  'day.wednesday': { en: 'Wednesday', th: 'พุธ' },
  'day.thursday': { en: 'Thursday', th: 'พฤหัสบดี' },
  'day.friday': { en: 'Friday', th: 'ศุกร์' },
  'day.saturday': { en: 'Saturday', th: 'เสาร์' },
  'day.sunday': { en: 'Sunday', th: 'อาทิตย์' },

  // Pagination
  'pagination.showing': { en: 'Showing', th: 'แสดง' },
  'pagination.of': { en: 'of', th: 'จาก' },
  'pagination.items': { en: 'items', th: 'รายการ' },
  'pagination.perPage': { en: 'Per page', th: 'ต่อหน้า' },
  'pagination.first': { en: 'First', th: 'หน้าแรก' },
  'pagination.previous': { en: 'Previous', th: 'ก่อนหน้า' },
  'pagination.next': { en: 'Next', th: 'ถัดไป' },
  'pagination.last': { en: 'Last', th: 'หน้าสุดท้าย' },

  // Reports
  'nav.reports': { en: 'Reports', th: 'รายงาน' },
  'reports.income': { en: 'Income Report', th: 'รายงานรายได้' },
  'reports.license': { en: 'License Expiry', th: 'ใบอนุญาตหมดอายุ' },
  'reports.treatments': { en: 'Treatment Summary', th: 'สรุปการรักษา' },
  'reports.doctors': { en: 'Doctor Fees', th: 'ค่าตอบแทนแพทย์' },
  'reports.patients': { en: 'Patient Statistics', th: 'สถิติผู้ป่วย' },

  // Report Filters
  'reports.branch': { en: 'Branch', th: 'สาขา' },
  'reports.allBranches': { en: 'All Branches', th: 'ทุกสาขา' },
  'reports.allMyBranches': { en: 'All My Branches', th: 'ทุกสาขาของฉัน' },
  'reports.dentist': { en: 'Dentist', th: 'ทันตแพทย์' },
  'reports.allDentists': { en: 'All Dentists', th: 'ทันตแพทย์ทั้งหมด' },
  'reports.period': { en: 'Period', th: 'ช่วงเวลา' },
  'reports.today': { en: 'Today', th: 'วันนี้' },
  'reports.thisWeek': { en: 'This Week', th: 'สัปดาห์นี้' },
  'reports.thisMonth': { en: 'This Month', th: 'เดือนนี้' },
  'reports.thisYear': { en: 'This Year', th: 'ปีนี้' },
  'reports.fromDate': { en: 'From', th: 'จากวันที่' },
  'reports.toDate': { en: 'To', th: 'ถึงวันที่' },
  'reports.print': { en: 'Print', th: 'พิมพ์' },
  'reports.exportCsv': { en: 'Export CSV', th: 'ส่งออก CSV' },

  // Income Report
  'reports.totalRevenue': { en: 'Total Revenue', th: 'รายได้รวม' },
  'reports.totalPaid': { en: 'Total Paid', th: 'ชำระแล้ว' },
  'reports.totalPending': { en: 'Total Pending', th: 'ค้างชำระ' },
  'reports.invoiceCount': { en: 'Invoices', th: 'ใบแจ้งหนี้' },
  'reports.byBranch': { en: 'By Branch', th: 'ตามสาขา' },
  'reports.byPaymentMethod': { en: 'By Payment Method', th: 'ตามวิธีชำระ' },
  'reports.dailyBreakdown': { en: 'Daily Breakdown', th: 'รายละเอียดรายวัน' },
  'reports.revenue': { en: 'Revenue', th: 'รายได้' },
  'reports.paid': { en: 'Paid', th: 'ชำระแล้ว' },
  'reports.pending': { en: 'Pending', th: 'ค้างชำระ' },
  'reports.invoices': { en: 'Invoices', th: 'ใบแจ้งหนี้' },
  'reports.date': { en: 'Date', th: 'วันที่' },
  'reports.paymentMethod': { en: 'Payment Method', th: 'วิธีชำระเงิน' },
  'reports.amount': { en: 'Amount', th: 'จำนวนเงิน' },
  'reports.count': { en: 'Count', th: 'จำนวน' },

  // Payment Methods
  'payment.cash': { en: 'Cash', th: 'เงินสด' },
  'payment.transfer': { en: 'Bank Transfer', th: 'โอนเงิน' },
  'payment.creditCard': { en: 'Credit Card', th: 'บัตรเครดิต' },
  'payment.debitCard': { en: 'Debit Card', th: 'บัตรเดบิต' },
  'payment.socialSecurity': { en: 'Social Security', th: 'ประกันสังคม' },
  'payment.insurance': { en: 'Insurance', th: 'ประกัน' },

  // License Expiry Report
  'reports.expiryMonth': { en: 'Expiry Month', th: 'เดือนหมดอายุ' },
  'reports.allMonths': { en: 'All Months', th: 'ทุกเดือน' },
  'reports.status': { en: 'Status', th: 'สถานะ' },
  'reports.expired': { en: 'Expired', th: 'หมดอายุแล้ว' },
  'reports.expiring': { en: 'Expiring', th: 'ใกล้หมดอายุ' },
  'reports.expiringSoon': { en: 'Expiring Soon', th: 'ใกล้หมดอายุ' },
  'reports.active': { en: 'Active', th: 'ใช้งาน' },
  'reports.total': { en: 'Total', th: 'รวม' },
  'reports.daysRemaining': { en: 'Days Remaining', th: 'วันที่เหลือ' },
  'reports.users': { en: 'Users', th: 'ผู้ใช้' },
  'branch.branches': { en: 'Branches', th: 'สาขา' },

  // Treatment Summary
  'reports.totalTreatments': { en: 'Total Treatments', th: 'การรักษาทั้งหมด' },
  'reports.avgPerTreatment': { en: 'Avg per Treatment', th: 'เฉลี่ยต่อการรักษา' },
  'reports.byCategory': { en: 'By Category', th: 'ตามหมวดหมู่' },
  'reports.topTreatments': { en: 'Top Treatments', th: 'การรักษายอดนิยม' },
  'reports.category': { en: 'Category', th: 'หมวดหมู่' },
  'reports.treatment': { en: 'Treatment', th: 'การรักษา' },
  'reports.avgPrice': { en: 'Avg Price', th: 'ราคาเฉลี่ย' },
  'reports.percentage': { en: '%', th: '%' },

  // Doctor Fee Report
  'reports.dentists': { en: 'Dentists', th: 'ทันตแพทย์' },
  'reports.totalDoctorFee': { en: 'Total Doctor Fee', th: 'ค่าตอบแทนแพทย์รวม' },
  'reports.specialty': { en: 'Specialty', th: 'ความชำนาญ' },
  'reports.doctorFee': { en: 'Doctor Fee', th: 'ค่าตอบแทน' },
  'reports.dfPercentage': { en: 'DF %', th: 'DF %' },

  // Patient Statistics
  'reports.totalPatients': { en: 'Total Patients', th: 'ผู้ป่วยทั้งหมด' },
  'reports.activePatients': { en: 'Active Patients', th: 'ผู้ป่วยที่ใช้งาน' },
  'reports.newPatients': { en: 'New Patients', th: 'ผู้ป่วยใหม่' },
  'reports.inPeriod': { en: '(In Period)', th: '(ในช่วงเวลา)' },
  'reports.byGender': { en: 'By Gender', th: 'ตามเพศ' },
  'reports.byAgeGroup': { en: 'By Age Group', th: 'ตามกลุ่มอายุ' },
  'reports.gender': { en: 'Gender', th: 'เพศ' },
  'reports.ageGroup': { en: 'Age Group', th: 'กลุ่มอายุ' },
  'reports.patientCount': { en: 'Patients', th: 'ผู้ป่วย' },
  'reports.under18': { en: 'Under 18', th: 'ต่ำกว่า 18 ปี' },
  'reports.over60': { en: 'Over 60', th: 'มากกว่า 60 ปี' },
  'patient.male': { en: 'Male', th: 'ชาย' },
  'patient.female': { en: 'Female', th: 'หญิง' },
  'patient.other': { en: 'Other', th: 'อื่นๆ' },
  'common.unknown': { en: 'Unknown', th: 'ไม่ทราบ' },

  // Catalog navigation
  'nav.products': { en: 'Products', th: 'สินค้า' },
  'nav.medications': { en: 'Medications', th: 'ยา' },
  // Product catalog
  'products': { en: 'Products', th: 'สินค้า' },
  'product_name': { en: 'Product Name', th: 'ชื่อสินค้า' },
  'no_products': { en: 'No products found', th: 'ไม่พบสินค้า' },
  'search_products': { en: 'Search products...', th: 'ค้นหาสินค้า...' },
  'sale_price': { en: 'Sale Price', th: 'ราคาขาย' },
  'low_stock': { en: 'Low Stock', th: 'สินค้าใกล้หมด' },
  // Medication catalog
  'medications': { en: 'Medications', th: 'ยา' },
  'medication': { en: 'Medication', th: 'ยา' },
  'no_medications': { en: 'No medications found', th: 'ไม่พบยา' },
  'search_medications': { en: 'Search medications...', th: 'ค้นหายา...' },
  'price_per_unit': { en: 'Price per Unit', th: 'ราคาต่อหน่วย' },
  'dosage_form': { en: 'Dosage Form', th: 'รูปแบบยา' },
  'expiry_date': { en: 'Expiry Date', th: 'วันหมดอายุ' },
  // Catalog columns and filters shared by both screens
  'category': { en: 'Category', th: 'หมวดหมู่' },
  'all_categories': { en: 'All Categories', th: 'ทุกหมวดหมู่' },
  'unit': { en: 'Unit', th: 'หน่วย' },
  'stock_quantity': { en: 'Stock', th: 'คงเหลือ' },
  'status': { en: 'Status', th: 'สถานะ' },
  // VAT
  'vat_mode': { en: 'VAT', th: 'ภาษีมูลค่าเพิ่ม' },
  'vat_none': { en: 'No VAT', th: 'ไม่มี VAT' },
  'vat_include': { en: 'Price includes VAT', th: 'ราคารวม VAT' },
  'vat_exclude': { en: 'Price excludes VAT', th: 'ราคาไม่รวม VAT' },
  'price_incl_vat': { en: 'Price incl. VAT', th: 'ราคารวม VAT' },
  // Catalog row status values (rendered via print_lang(row.status, ...))
  'active': { en: 'Active', th: 'ใช้งาน' },
  'inactive': { en: 'Inactive', th: 'ไม่ใช้งาน' },
  'discontinued': { en: 'Discontinued', th: 'เลิกใช้' },
  // Dosage forms (rendered via print_lang(row.dosage_form, ...))
  'tablet': { en: 'Tablet', th: 'เม็ด' },
  'capsule': { en: 'Capsule', th: 'แคปซูล' },
  'liquid': { en: 'Liquid', th: 'ยาน้ำ' },
  'injection': { en: 'Injection', th: 'ยาฉีด' },
  'topical': { en: 'Topical', th: 'ยาทา' },
  'gel': { en: 'Gel', th: 'เจล' },
  'rinse': { en: 'Rinse', th: 'น้ำยาบ้วนปาก' },
  'powder': { en: 'Powder', th: 'ผง' },
  'spray': { en: 'Spray', th: 'สเปรย์' },
  'other': { en: 'Other', th: 'อื่นๆ' },

  // The admin console browses the catalogs; the clinic app owns the editing.
  'catalog.readOnly': {
    en: 'View only — manage the catalog in the clinic app',
    th: 'ดูอย่างเดียว — จัดการรายการในแอปคลินิก',
  },
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('admin_language') || 'th';
  });

  useEffect(() => {
    localStorage.setItem('admin_language', currentLanguage);
  }, [currentLanguage]);

  const toggleLanguage = () => {
    setCurrentLanguage(prev => prev === 'en' ? 'th' : 'en');
  };

  const print_lang = (key, defaultValue = '') => {
    const translation = translations[key];
    if (!translation) return defaultValue || key;
    return translation[currentLanguage] || translation['en'] || defaultValue || key;
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, setCurrentLanguage, toggleLanguage, print_lang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
